/*
 * @Description: 获取账户信息
 * @Author: gao shuai
 * @Date: 2020-05-14 09:27:03
 * @LastEditTime: 2020-08-19 15:01:35
 * @LastEditors: gao shuai
 */

import api from '../services/api';
export default {
  // 获取银行信息
  async bankInfo(params) {
  return api({ url: '/api/HomePage/GetBankListAsync', method: 'get', params });
  },
  // 获取银行下拉
  async bankDrow(params) {
  return api({ url: '/api/HomePage/GetMerchantCenterBanksAsync', method: 'get', params });
  },
  // 更换通讯密钥
  async changeKey(params) {
  return api({ url: '/api/HomePage/SecretKeyUpdateAsync', method: 'post', data: params });
  },
  // 编辑在线客服
  async editlLineQQ(params) {
  return api({ url: '/api/HomePage/ServiceStatePQUpdateAsync', method: 'post', data: params });
  },
  // 保存银行帐户信息
  async savebankInfo(params) {
  return api({ url: '/api/HomePage/AddBanksAsync', method: 'post', data: params });
  },
  // 检查是否绑定微信公众号
  async isBandweixi(params) {
  return api({ url: '/api/HomePage/IsBound', method: 'get', params });
  },
  // 检查是否绑定微信公众号轮询
  async isBandsingle(params) {
  return api({ url: '/api/HomePage/IsSignalBound', method: 'get', params });
  },
  // 获取用户二维码
  async userCode(params) {
  return api({ url: '/api/HomePage/GetQrImage', method: 'get', params });
  },
  // 获取公众号展示二维码（无需密码）
  async getWxImage(params) {
  return api({ url: '/api/homepage/getwximage', method: 'get', params });
  },
  // 解绑微信公众号
  async unbindwei(params) {
  return api({ url: '/api/HomePage/UnbindWx', method: 'post', data: params });
  },
  // 获取二级密码和帐户是否完善的状态
  async getPersonState(params) {
  return api({ url: '/api/HomePage/CheckAllTenantInformationAsync', method: 'get', params });
  },
  // 修改二级密码和帐户信息
  async setInfo(params) {
  return api({ url: '/api/UserCenter/ChangeBankSecondaryPassword', method: 'post', data: params });
  },
  // 获取银行详细信息
  async bankDetail(params) {
  return api({ url: '/api/UserCenter/CheckBankDetailByPassword', method: 'post', data: params });
  },
  /* -----------------------1.帐号安全---------------------- */
  // 获取商户安全IP设置
  async getsafeIp(params) {
  return api({ url: '/api/UserCenter/GetSafetyIP', method: 'get', params });
  },
  // 设置商户安全IP设置
  async setsafeIp(params) {
  return api({ url: '/api/UserCenter/SetSafetyIP', method: 'post', data: params });
  },
  /* -----------------------1.结算记录---------------------- */
  // 获取结算列表
  async settleRecrod(params) {
  return api({ url: '/api/UserCenter/GetSuccessSettlements', method: 'get', params });
  },
  // 获取已绑定的微信号
  async isbindWeixin(params) {
  return api({ url: '/api/Weixin/GetAlreadyBoundWxs', method: 'get', params });
  },
  // 微信权限管理
  async changeWeixin(params) {
  return api({ url: '/api/Weixin/ChangePermissionState', method: 'post', data: params });
  },
  // 微信权限管理的二级密码
  async checkSecondary(params) {
  return api({ url: '/api/UserCenter/CheckSecondary', method: 'post', data: params });
  },
  // 二级密码的修改
  async changePassword(params) {
  return api({ url: '/api/UserCenter/SetSecondaryPasswordAsync', method: 'post', data: params });
  },
  // 分佣
  async FenYongPaid(params) {
  return api({ url: '/api/Cashier/FenYongPaid', method: 'post', data: params });
  },
  async getUserBankDetails(params) {
  return api({ url: '/api/UserCenter/getUserBankDetails', method: 'post', data: params });
  },
  async elecSign(params) {
  return api({ url: '/api/HomePage/SendElectronicSign', method: 'post', data: params });
  }
};
